import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

@Component({
  selector: "app-as-team-header",
  templateUrl: "./as-team-header.component.html",
  styleUrls: ["./as-team-header.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AsTeamHeaderComponent {
  @Input() public name: string = "";
}
